window.MobileMenu = window.MobileMenu || {
  init() {
    this.bindListeners();
  },

  open() {
    document.querySelector(".menu-drawer")?.classList.add("menu-drawer--active");
  },

  close() {
    document.querySelector(".menu-drawer")?.classList.remove("menu-drawer--active");
  },

  bindListeners() {
    // OPEN
    document.querySelector(".header-menuButton")?.addEventListener("click", () => {
      this.open();
    });

    // CLOSE
    document.querySelector(".menu-closeButton")?.addEventListener("click", () => {
      this.close();
    });

    // CLICK OVERLAY TO CLOSE
    document.querySelector(".menu-drawer")?.addEventListener("click", () => {
      this.close();
    });

    document.querySelector(".menu-drawer-box")?.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  },
};

window.MobileMenu.init();
